import API from '@/views/Fdc/Apis/'

/**
 * EQP Save Modal Component
 * EQP 정보를 저장하는 component
 */
export default {
  name: 'eqpEditModal',
  /**
   * Modal 표시 여부
   * @param {Boolean} visible
   *
   * Modal 초기 data
   * @param {Object} initValue
   *
   * Save Method 실행 여부
   * @param {Boolean} saveReady
   *
   * Save 종료 시 실행 method
   * @param {Function} saveComplete
   *
   * Save 취소 시 실행 method
   * @param {Function} cancelSave
   *
   * Save 시 EQP Tree를 refresh하기 위한 method
   * @param {Function} refreshEqpTree
  */
  props: [
    'visible',
    'initValue',
    'saveReady',
    'saveComplete',
    'cancelSave',
    'refreshEqpTree'
  ],
  watch: {
    /**
     * initValue 변화 감지
     * 초기 data를 설정합니다.
     */
    initValue: {
      deep: true,
      handler () {
        this.initData()
      }
    },
    /**
     * saveReady 변화 감지
     * saveReady가 true일 때 saveData method를 실행합니다.
     */
    saveReady: function () {
      if (this.saveReady) {
        this.saveData()
      }
    }
  },
  beforeMount () {
    this.initData()
  },
  methods: {
    /**
     * 초기 Data 설정
     */
    initData () {
      if (this.initValue.fab) {
        this.fab = this.initValue.fab
        this.line = this.initValue.line
        this.lineList = this.getLineList(this.initValue.fab)
        this.areaList = this.getAreaList(this.initValue.fab)
      }

      if (this.initValue.fab && this.initValue.area) {
        this.area = this.initValue.area
        this.vendorList = this.getVendorList(this.initValue.fab, this.initValue.area)
      }

      if (this.initValue.fab && this.initValue.area && this.initValue.vendor) {
        this.vendor = this.initValue.vendor
        this.eqpModelList = this.getEqpModelList(this.initValue.fab, this.initValue.area, this.initValue.vendor)
      }

      if (this.initValue.fab && this.initValue.area && this.initValue.vendor && this.initValue.eqpModel) {
        this.eqpModel = this.initValue.eqpModel
      }

      if (this.initValue.saveType === 'Edit') {
        this.eqpId = this.initValue.eqpId
        this.moduleId = this.initValue.moduleId
        this.eqpName = this.initValue.eqpName
      }
      this.eqpMainYn = this.initValue.eqpMainYn
      this.useYn = this.initValue.useYn
    },
    /**
     * Data 초기화
     */
    resetData () {
      this.fab = null
      this.line = null
      this.area = null
      this.vendor = null
      this.eqpModel = null
      this.eqpId = null
      this.moduleId = null
      this.eqpMainYn = null
      this.eqpName = null
      this.useYn = null
      this.lineList = []
      this.areaList = []
      this.vendorList = []
      this.eqpModelList = []
    },
    /**
     * EQP 저장
     */
    async saveData () {
      let self = this

      let mustSaveRows = [{
        fab: this.fab,
        line: this.line,
        area: this.area,
        vendor: this.vendor,
        eqpModel: this.eqpModel,
        eqpMainYn: this.eqpMainYn,
        eqpId: this.eqpId,
        moduleId: this.moduleId,
        eqpName: this.eqpName,
        useYn: this.useYn
      }]

      if (!this.saveValidation(mustSaveRows)) {
        this.cancelSave()
        return
      }

      let message = ''

      message += this.$t('fdc.COMMON.MESSAGE.CONFIRM_SAVE')

      this.$dialog.confirm({
        message: message,
        cancelText: this.$t('fdc.COMMON.BUTTON.CANCEL'),
        confirmText: this.$t('fdc.COMMON.BUTTON.CONFIRM'),
        onConfirm: function () {
          function saveLastProcess (response) {
            if (response != null && response.status === 200) {
              self.$dialog.alert(self.$t('fdc.COMMON.MESSAGE.SUCCEED_SAVE'))

              // Refresh EQP Tree
              self.refreshEqpTree()

              // Modal Close
              self.resetData()
              self.saveComplete()
            } else {
              self.$dialog.alert(self.$t('fdc.COMMON.MESSAGE.FAILED_SAVE'))
            }
          }

          if (mustSaveRows.length > 0) {
            API.BaseInfo.addEqp(mustSaveRows).then(result => {
              saveLastProcess(result)
            })
          }
        },
        onCancel: function () {
          self.cancelSave()
        }
      })
    },
    /**
     * EQP Save Validation
     * @param {Array} rows save data 배열
     * @returns {Boolean} validation 성공 여부
     */
    saveValidation (rows) {
      for (let i in rows) {
        if (!rows[i].fab || rows[i].fab.trim() === '') {
          this.$dialog.alert(this.$t('fdc.COMMON.MESSAGE.INFORM_ITEM_NOT_ENTERED', ['Fab']))
          return false
        } else if (!rows[i].line || rows[i].line.trim() === '') {
          this.$dialog.alert(this.$t('fdc.COMMON.MESSAGE.INFORM_ITEM_NOT_ENTERED', ['Line']))
          return false
        } else if (!rows[i].area || rows[i].area.trim() === '') {
          this.$dialog.alert(this.$t('fdc.COMMON.MESSAGE.INFORM_ITEM_NOT_ENTERED', ['Area']))
          return false
        } else if (!rows[i].vendor || rows[i].vendor.trim() === '') {
          this.$dialog.alert(this.$t('fdc.COMMON.MESSAGE.INFORM_ITEM_NOT_ENTERED', ['Vendor']))
          return false
        } else if (!rows[i].eqpModel || rows[i].eqpModel.trim() === '') {
          this.$dialog.alert(this.$t('fdc.COMMON.MESSAGE.INFORM_ITEM_NOT_ENTERED', ['Eqp Model']))
          return false
        } else if (!rows[i].eqpId || rows[i].eqpId.trim() === '') {
          this.$dialog.alert(this.$t('fdc.COMMON.MESSAGE.INFORM_ITEM_NOT_ENTERED', ['Eqp ID']))
          return false
        } else if (!rows[i].moduleId || rows[i].moduleId.trim() === '') {
          this.$dialog.alert(this.$t('fdc.COMMON.MESSAGE.INFORM_ITEM_NOT_ENTERED', ['Module ID']))
          return false
        } else if (!rows[i].eqpMainYn || rows[i].eqpMainYn.trim() === '') {
          this.$dialog.alert(this.$t('fdc.COMMON.MESSAGE.INFORM_ITEM_NOT_ENTERED', ['Eqp Main']))
          return false
        } else if (!rows[i].eqpName || rows[i].eqpName.trim() === '') {
          this.$dialog.alert(this.$t('fdc.COMMON.MESSAGE.INFORM_ITEM_NOT_ENTERED', ['Eqp Name']))
          return false
        } else if (!rows[i].useYn || rows[i].useYn.trim() === '') {
          this.$dialog.alert(this.$t('fdc.COMMON.MESSAGE.INFORM_ITEM_NOT_ENTERED', ['Usable']))
          return false
        }
        let isNotMainYn = true
        for (let j in this.eqpMainYnList) {
          if (rows[i].eqpMainYn === this.eqpMainYnList[j].eqpMainYn) {
            isNotMainYn = false
          }
        }
        if (isNotMainYn) {
          this.$dialog.alert(this.$t('fdc.COMMON.MESSAGE.INFORM_ITEM_NOT_VALID', ['Eqp Main']))
          return false
        }
        let isNotUseYn = true
        for (let j in this.useYnList) {
          if (rows[i].useYn === this.useYnList[j].useYn) {
            isNotUseYn = false
          }
        }
        if (isNotUseYn) {
          this.$dialog.alert(this.$t('fdc.COMMON.MESSAGE.INFORM_ITEM_NOT_VALID', ['Usable']))
          return false
        }
      }
      return true
    },
    /**
     * Area Combobox change method
     * Area 변경 시 vendor 목록 조회 및 eqpModel 목록 초기화를 실행합니다.
     */
    changeArea () {
      this.getVendorList(this.fab, this.area)
      this.eqpModelList = []
    },
    /**
     * Vendor Combobox change method
     * Vendor 변경 시 eqpModel 목록 조회를 실행합니다.
     */
    changeVendor () {
      this.getEqpModelList(this.fab, this.area, this.vendor)
    },
    /**
     * Line Key 목록 조회
     * @param {String} fab fab
     */
    async getLineList (fab) {
      let payload = {
        fab: fab,
        useYn: 'Y'
      }
      let data = await API.BaseInfo.getLinesString(payload)
      this.lineList = data
    },
    /**
     * Area Key 목록 조회
     * @param {String} fab fab
     */
    async getAreaList (fab) {
      let payload = {
        fab: fab,
        useYn: 'Y'
      }
      let data = await API.BaseInfo.getAreasString(payload)
      this.areaList = data
    },
    /**
     * Vendor Key 목록 조회
     * @param {String} fab fab
     * @param {String} area area
     */
    async getVendorList (fab, area) {
      let payload = {
        fab: fab,
        area: area,
        useYn: 'Y'
      }
      let data = await API.BaseInfo.getVendersString(payload)
      this.vendorList = data
    },
    /**
     * Eqp Model Key 목록 조회
     * @param {String} fab fab
     * @param {String} area area
     * @param {String} vendor vendor
     */
    async getEqpModelList (fab, area, vendor) {
      let payload = {
        fab: fab,
        area: area,
        vendor: vendor,
        useYn: 'Y'
      }
      let data = await API.BaseInfo.getEqpModelsString(payload)
      this.eqpModelList = data
    }
  },
  data () {
    return {
      fab: null, // Fab data
      line: null, // Line data
      area: null, // Area data
      vendor: null, // Vendor data
      eqpModel: null, // EqpModel data
      eqpId: null, // EQP ID data
      moduleId: null, // Module ID data
      eqpMainYn: null, // EQP Main YN data
      eqpName: null, // EQP Name data
      useYn: null, // Use YN data
      lineList: [], // Line Key 목록 배열
      areaList: [], // Area Key 목록 배열
      vendorList: [], // Vendor Key 목록 배열
      eqpModelList: [], // EqpModel Key 목록 배열
      eqpMainYnList: [
        { eqpMainYn: 'Y' },
        { eqpMainYn: 'N' }
      ], // EQP Main YN dataMap 배열
      useYnList: [
        { useYn: 'Y' },
        { useYn: 'N' }
      ] // Use YN dataMap 배열
    }
  }
}
